import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const NextIcon = createSvgIcon(
  <path
    d="M10 16L14 12L10 8"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    fill="transparent"
  />,
  "NextIcon"
);
